import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent.tsx';
import {
  DateWidgetFormats,
  DefaultWidgetDateFormat,
  type IDateWidget,
} from './IDateWidget.ts';

export const dateInputConfigValidator = CommonInputWidgetConfigSchema.shape({
  type: yup.string().exact(WidgetType.Date).required(),
  dateFormat: yup
    .string()
    .oneOf(
      DateWidgetFormats.map(f => f.key),
      'Formato data non valido',
    )
    .notRequired()
    .nullable()
    .label('Formato data'),
}) satisfies yup.ObjectSchema<IDateWidget>;

export type IDateWidgetConfigComponentProps =
  IWidgetComponentProps<IDateWidget>;

export function DateWidgetConfigComponent(
  props: IDateWidgetConfigComponentProps,
) {
  return (
    <>
      <CommonConfigComponent {...props} />
      <FormItem name="dateFormat" label="Formato data">
        <SelectInput
          name="dateFormat"
          options={DateWidgetFormats.map(f => ({
            value: f.key,
            label: f.label,
          }))}
          placeholder={DefaultWidgetDateFormat.label}
          allowClear
        />
      </FormItem>
    </>
  );
}
